module.exports = __webpack_public_path__ + "static/media/signupNewsletter.fc745225.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/signupNewsletter.png
// module id = 48
// module chunks = 0